import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { managers } from '../data/dummyData';

const BookingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const stateManager = location.state?.manager;
  const price = location.state?.price;
  const furniture = location.state?.furniture;
  const serviceType = location.state?.serviceType || 'verify_delivery';

  const [selectedManager, setSelectedManager] = useState(stateManager || managers[0]);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [memo, setMemo] = useState('');
  const [step, setStep] = useState(1); // 1: 예약 입력, 2: 확인, 3: 완료
  const [showManagerPicker, setShowManagerPicker] = useState(false);

  const today = new Date();
  const dateOptions = Array.from({ length: 7 }, (_, i) => {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const dayName = ['일', '월', '화', '수', '목', '금', '토'][d.getDay()];
    return {
      value: `${d.getFullYear()}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
      label: i === 0 ? '오늘' : i === 1 ? '내일' : `${month}/${day}(${dayName})`,
    };
  });

  const timeSlots = [
    '09:00~11:00', '10:00~12:00', '11:00~13:00',
    '13:00~15:00', '14:00~16:00', '15:00~17:00',
    '16:00~18:00', '17:00~19:00',
  ];

  const totalPrice = price?.total || 35000;

  const handleConfirm = () => {
    if (!selectedDate || !selectedTime) return;
    setStep(2);
  };

  const handleFinalBook = () => {
    setStep(3);
  };

  if (step === 3) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: 40, textAlign: 'center', background: 'white' }}>
        <div style={{ fontSize: 80, marginBottom: 20 }}>🎉</div>
        <div style={{ fontWeight: 800, fontSize: 24, color: '#1F2937', marginBottom: 8 }}>예약 완료!</div>
        <div style={{ fontSize: 15, color: '#6B7280', marginBottom: 24, lineHeight: 1.7 }}>
          <strong style={{ color: '#FF6B35' }}>{selectedManager.name}</strong> 영차매니저가<br/>
          요청을 수락했습니다! 🚐<br/>
          <span style={{ fontSize: 13 }}>예약번호: ORD-20260303-0042</span>
        </div>

        <div style={{ background: '#F9FAFB', borderRadius: 16, padding: 20, width: '100%', marginBottom: 24, textAlign: 'left' }}>
          {[
            { label: '매니저', val: selectedManager.name },
            { label: '상품', val: furniture?.name || '가구 배송' },
            { label: '날짜', val: selectedDate },
            { label: '시간', val: selectedTime },
            { label: '총 요금', val: `${totalPrice.toLocaleString()}원` },
          ].map((item, i) => (
            <div key={i} className="info-row">
              <span className="info-key">{item.label}</span>
              <span className="info-val">{item.val}</span>
            </div>
          ))}
        </div>

        <div style={{ background: '#e8f8ef', borderRadius: 12, padding: 16, width: '100%', marginBottom: 24 }}>
          <div style={{ fontWeight: 700, fontSize: 14, color: '#27AE60', marginBottom: 6 }}>📱 다음 단계 안내</div>
          <div style={{ fontSize: 13, color: '#166534', lineHeight: 1.7 }}>
            1. 매니저가 판매자에게 연락합니다<br/>
            2. 현장 방문 후 사진을 전송해 드립니다<br/>
            3. 검증 완료 후 배송 진행 여부를 선택하세요<br/>
            4. 배송 완료 시 실시간으로 알림을 보내드립니다
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, width: '100%' }}>
          <button
            onClick={() => navigate('/tracking')}
            style={{
              flex: 1, padding: '16px', borderRadius: 16,
              background: 'white', border: '2px solid #FF6B35',
              color: '#FF6B35', fontWeight: 700, cursor: 'pointer'
            }}
          >
            배송 추적
          </button>
          <button
            onClick={() => navigate('/')}
            style={{
              flex: 1, padding: '16px', borderRadius: 16,
              background: '#FF6B35', color: 'white', border: 'none',
              fontWeight: 700, cursor: 'pointer'
            }}
          >
            홈으로
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="page-white">
      {/* 헤더 */}
      <div style={{ background: 'linear-gradient(135deg, #2C3E50 0%, #34495E 100%)', padding: '20px 20px 24px' }}>
        <button
          onClick={() => step > 1 ? setStep(step - 1) : navigate(-1)}
          style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 10, padding: '8px 12px', color: 'white', cursor: 'pointer', marginBottom: 12 }}
        >← 뒤로</button>
        <div style={{ color: 'white', fontSize: 22, fontWeight: 800, marginBottom: 4 }}>
          📅 {step === 1 ? '예약 정보 입력' : '예약 확인'}
        </div>
        <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13 }}>
          {step === 1 ? '날짜와 시간을 선택해 주세요' : '예약 내용을 확인해 주세요'}
        </div>
        {/* 단계 표시 */}
        <div style={{ display: 'flex', gap: 6, marginTop: 12 }}>
          {['예약 입력', '확인', '완료'].map((s, i) => (
            <div key={i} style={{
              flex: 1, height: 4, borderRadius: 2,
              background: i < step ? '#FF6B35' : 'rgba(255,255,255,0.2)'
            }}/>
          ))}
        </div>
      </div>

      {step === 1 && (
        <div style={{ padding: '24px 20px 100px' }}>
          {/* 매니저 선택 */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937', marginBottom: 10 }}>
              🧑 담당 영차매니저
            </div>
            <div
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '14px', background: '#FFF0EB', borderRadius: 14,
                border: '2px solid #FF6B35', cursor: 'pointer'
              }}
              onClick={() => setShowManagerPicker(true)}
            >
              <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <div style={{ fontSize: 28 }}>{selectedManager?.emoji}</div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937' }}>{selectedManager?.name}</div>
                  <div style={{ fontSize: 12, color: '#9CA3AF' }}>⭐ {selectedManager?.rating} • {selectedManager?.distance}km</div>
                </div>
              </div>
              <div style={{ fontSize: 13, color: '#FF6B35', fontWeight: 600 }}>변경 ›</div>
            </div>
          </div>

          {/* 날짜 선택 */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937', marginBottom: 10 }}>
              📅 날짜 선택
            </div>
            <div className="scroll-x">
              {dateOptions.map(d => (
                <button
                  key={d.value}
                  onClick={() => setSelectedDate(d.value)}
                  style={{
                    minWidth: 70, padding: '12px 10px', border: `2px solid ${selectedDate === d.value ? '#FF6B35' : '#E5E7EB'}`,
                    borderRadius: 12, background: selectedDate === d.value ? '#FFF0EB' : 'white',
                    color: selectedDate === d.value ? '#FF6B35' : '#4B5563',
                    fontWeight: 700, fontSize: 13, cursor: 'pointer', textAlign: 'center'
                  }}
                >
                  {d.label}
                </button>
              ))}
            </div>
          </div>

          {/* 시간 선택 */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937', marginBottom: 10 }}>
              ⏰ 시간 선택
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              {timeSlots.map(t => (
                <button
                  key={t}
                  onClick={() => setSelectedTime(t)}
                  style={{
                    padding: '12px 8px', border: `2px solid ${selectedTime === t ? '#FF6B35' : '#E5E7EB'}`,
                    borderRadius: 12, background: selectedTime === t ? '#FFF0EB' : 'white',
                    color: selectedTime === t ? '#FF6B35' : '#4B5563',
                    fontWeight: selectedTime === t ? 700 : 500, fontSize: 13, cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                >
                  {t}
                </button>
              ))}
            </div>
          </div>

          {/* 메모 */}
          <div className="input-group">
            <label className="input-label">📝 특이사항 (선택)</label>
            <textarea
              className="input-field"
              value={memo}
              onChange={e => setMemo(e.target.value)}
              placeholder="예: 3층이지만 계단이 좁아요, 소파 분해 가능합니다..."
              rows={3}
              style={{ resize: 'none' }}
            />
          </div>

          {/* 요금 요약 */}
          <div style={{ background: '#F9FAFB', borderRadius: 14, padding: 16, marginBottom: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: 14, color: '#1F2937' }}>
                  {furniture?.name || '가구 배송'}
                </div>
                <div style={{ fontSize: 12, color: '#9CA3AF', marginTop: 2 }}>
                  {serviceType === 'verify_delivery' ? '검증+배송' : serviceType === 'verify' ? '검증만' : '배송만'}
                </div>
              </div>
              <div style={{ fontWeight: 800, fontSize: 20, color: '#FF6B35' }}>
                {totalPrice.toLocaleString()}원
              </div>
            </div>
          </div>

          <button
            onClick={handleConfirm}
            disabled={!selectedDate || !selectedTime}
            style={{
              width: '100%', padding: '16px', borderRadius: 16,
              background: selectedDate && selectedTime ? '#FF6B35' : '#E5E7EB',
              color: selectedDate && selectedTime ? 'white' : '#9CA3AF',
              border: 'none', fontWeight: 800, fontSize: 16,
              cursor: selectedDate && selectedTime ? 'pointer' : 'not-allowed',
              transition: 'all 0.2s'
            }}
          >
            {selectedDate && selectedTime ? '예약 확인하기 →' : '날짜와 시간을 선택해 주세요'}
          </button>
        </div>
      )}

      {step === 2 && (
        <div style={{ padding: '24px 20px 100px' }}>
          <div style={{ background: '#FFF0EB', borderRadius: 16, padding: 20, marginBottom: 20, border: '1px solid #FFD0B5' }}>
            <div style={{ fontWeight: 700, fontSize: 16, color: '#FF6B35', marginBottom: 14 }}>
              🚐 예약 최종 확인
            </div>
            {[
              { label: '담당 매니저', val: `${selectedManager?.name} (⭐${selectedManager?.rating})` },
              { label: '차량', val: selectedManager?.vehicle },
              { label: '상품', val: furniture?.name || '가구 배송' },
              { label: '서비스 유형', val: serviceType === 'verify_delivery' ? '검증+배송' : serviceType === 'verify' ? '현장 검증' : '용달 배송' },
              { label: '예약 날짜', val: selectedDate },
              { label: '예약 시간', val: selectedTime },
              { label: '특이사항', val: memo || '없음' },
            ].map((item, i) => (
              <div key={i} className="info-row">
                <span className="info-key">{item.label}</span>
                <span className="info-val" style={{ fontSize: 13, maxWidth: '55%', textAlign: 'right' }}>{item.val}</span>
              </div>
            ))}
            <div style={{ borderTop: '2px solid #FFD0B5', marginTop: 12, paddingTop: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontWeight: 800, fontSize: 16, color: '#1F2937' }}>결제 금액</span>
              <span style={{ fontWeight: 800, fontSize: 24, color: '#FF6B35' }}>{totalPrice.toLocaleString()}원</span>
            </div>
          </div>

          {/* 결제 방법 */}
          <div style={{ background: 'white', borderRadius: 16, padding: 20, marginBottom: 20, border: '1px solid #E5E7EB' }}>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937', marginBottom: 12 }}>💳 결제 방법</div>
            {['카카오페이', '네이버페이', '신용/체크카드', '계좌이체'].map((method, i) => (
              <div
                key={i}
                style={{
                  padding: '12px 16px', borderRadius: 10, border: `2px solid ${i === 0 ? '#FF6B35' : '#E5E7EB'}`,
                  background: i === 0 ? '#FFF0EB' : 'white', marginBottom: 8, cursor: 'pointer',
                  display: 'flex', alignItems: 'center', gap: 10
                }}
              >
                <span style={{ fontSize: 18 }}>{['💛', '💚', '💳', '🏦'][i]}</span>
                <span style={{ fontWeight: i === 0 ? 700 : 500, fontSize: 14, color: i === 0 ? '#FF6B35' : '#4B5563' }}>{method}</span>
                {i === 0 && <span style={{ marginLeft: 'auto', fontSize: 11, background: '#FF6B35', color: 'white', padding: '2px 8px', borderRadius: 6, fontWeight: 700 }}>선택됨</span>}
              </div>
            ))}
          </div>

          <div style={{ background: '#e8f8ef', borderRadius: 12, padding: 14, marginBottom: 20 }}>
            <div style={{ fontSize: 13, color: '#166534', lineHeight: 1.7 }}>
              ✅ 현장 검증 시 하자 발견되면 <strong>검증비(15,000원)만</strong> 청구됩니다<br/>
              ✅ 배송비는 배송 완료 후 청구됩니다<br/>
              ✅ 결제 취소는 배송 48시간 전까지 가능합니다
            </div>
          </div>

          <button
            onClick={handleFinalBook}
            style={{
              width: '100%', padding: '16px', borderRadius: 16,
              background: '#FF6B35', color: 'white', border: 'none',
              fontWeight: 800, fontSize: 16, cursor: 'pointer',
              boxShadow: '0 4px 16px rgba(255,107,53,0.4)'
            }}
          >
            🚐 지금 예약하기 ({totalPrice.toLocaleString()}원)
          </button>
        </div>
      )}

      {/* 매니저 선택 모달 */}
      {showManagerPicker && (
        <div className="modal-overlay" onClick={() => setShowManagerPicker(false)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div className="modal-handle"/>
            <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 16 }}>🧑 매니저 선택</div>
            {managers.filter(m => m.status === 'online').map(mgr => (
              <div
                key={mgr.id}
                onClick={() => { setSelectedManager(mgr); setShowManagerPicker(false); }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 12, padding: '14px',
                  borderRadius: 12, border: `2px solid ${selectedManager?.id === mgr.id ? '#FF6B35' : '#E5E7EB'}`,
                  background: selectedManager?.id === mgr.id ? '#FFF0EB' : 'white',
                  marginBottom: 10, cursor: 'pointer'
                }}
              >
                <div style={{ fontSize: 28 }}>{mgr.emoji}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{mgr.name}</div>
                  <div style={{ fontSize: 12, color: '#9CA3AF' }}>⭐ {mgr.rating} • {mgr.distance}km • {mgr.vehicle}</div>
                </div>
                {selectedManager?.id === mgr.id && <span style={{ color: '#FF6B35', fontWeight: 700 }}>✓</span>}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingPage;
